<template>
  <div class="container-mapas">
    <div class="left-box">
      <div class="title-section">
        <h2>Norte, Centro-Oeste e Nordeste Ocidental</h2>
      </div>
      <div>
          <!-- <p class="texto-apoio">Os estados de Rondônia, Amapá, Amazonas, Pará, Acre, Mato Grosso, Mato Grosso do Sul, Tocantins, Maranhão e Piauí foram reunidos na região denominada Norte, Centro-Oeste e Nordeste Ocidental.</p> -->
          <div class="downloand">
              <ul>
								<li>
                      <p>Fichas da Região</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Norte, Centro-Oeste e Nordeste Ocidental.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Acre - AC</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Acre.zip" target="_blank">Download</a>
                  </li>
										<li>
                      <p>Amapá - AP</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Amapa.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Amazonas - AM</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Amazonas.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Distrito Federal - DF</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Distrito Federal.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Goiás - GO</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Goias.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Maranhão - MA</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Maranhao.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Mato Grosso - MT</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Mato Grosso.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Mato Grosso do Sul - MS</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Mato Grosso do Sul.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Pará - PA</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Para.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Piauí - PI</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Piaui.zip" target="_blank">Download</a>
                  </li>
									<li>
                      <p>Rondônia - RO</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Rondonia.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Roraima - RR</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Roraima.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Tocantins - TO</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Tocantins.zip" target="_blank">Download</a>
                  </li>
              </ul>
          </div>
          <div class="interacao-intervencao">
			<svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22">
    			<path fill="#7E7E7E" fill-rule="evenodd" d="M13.278 12.965l-5.436-.492-.008-6.237C7.834 5.8 7.464 5 6.57 5c-.695 0-1.264.554-1.264 1.236V16.74l-1.049-1.473a1.255 1.255 0 0 0-1.894-.162 1.206 1.206 0 0 0-.141 1.559L4.94 21.62c.235.335.623.38 1.037.38h6.086c1.201 0 2.234-.678 2.47-1.832l.418-4.45c.249-1.223-.469-2.359-1.673-2.753M1.3 9C.582 9 0 8.464 0 7.8V6.3c0-8.4 13-8.4 13 0v1.5c0 .664-.582 1.2-1.3 1.2-.718 0-1.3-.536-1.3-1.2V6.3c0-4.8-7.8-4.8-7.8 0v1.5c0 .664-.582 1.2-1.3 1.2"/>
			</svg>
			<p>Explore o mapa e tenha acesso aos detalhes e à ficha-modelo de cada intervenção.</p>
		  </div>
      </div>
    </div>
    <div class="right-box">
      <div class="mapa">
				 <Modal />
         <SvgPanZoom :dblClickZoomEnabled="false" :zoomEnabled="true" :controlIconsEnabled="true" :fit="false"  :center="true" :contain="true">
             <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1076 1068" style="enable-background:new 0 0 1076 1068;" xml:space="preserve">
<polygon class="st0" points="905.4,476.1 865.6,478.1 832,516.4 802.9,501.5 801.9,505.7 802.4,505.8 833,521.5 867.5,482.1
	906.6,479.3 924.6,468.5 922.2,466.5 "/>
<path class="st0" d="M926.4,310.5l18.9,120.2l-4.2-0.9H941l-19-120.4L926.4,310.5z"/>
<polygon class="st1" points="922.1,309.4 941.1,429.8 941.1,432.6 922.2,466.5 922.2,466.5 905.4,476.1 865.6,478.1 832,516.4
	802.9,501.5 815.9,444.8 883.1,413.3 884.3,412.7 882.9,355.5 915.8,307.8 "/>
<polygon class="st0" points="913.9,303.2 925.8,306.1 925.7,306.3 921.7,306.9 922.1,309.4 915.8,307.8 917.2,305.7 913.9,303.4 "/>
<polygon class="st0" points="917.2,305.7 915.8,307.8 911.6,306.8 913.9,303.4 "/>
<polygon class="st0" points="915.8,307.8 882.9,355.5 884.3,412.7 883.1,413.3 815.9,444.8 802.9,501.5 799,499.5 799.3,498.8
	812.4,442 880.1,410.1 878.8,354.3 911.6,306.8 "/>
<path class="st1" d="M911.6,306.8l-32.8,47.6l1.3,55.8L812.4,442l-13.1,56.8c-7.5-6.8-14.8-13.9-15.8-15.8c0-2.6,3.7-17.9,7.5-31.6
	l0.3-1.3l-26.7-21.2c2.1-16.2,5.5-41.4,6.5-43.8c0.3-0.7,0.3-1.4,0.1-2.1c-0.5-1.1-1.5-3.7-24.7-12.1l57.7-91.2L911.6,306.8z"/>
<polygon class="st0" points="805,278.5 804.2,279.7 802.6,279.3 802.5,279.2 800.3,278.3 801.5,276.3 "/>
<path class="st0" d="M802.9,501.5l-1,4.2l-0.2,0.7l-2.6-2.3l-0.7-0.7l0.2-4.1l0.3,0.1L802.9,501.5z"/>
<path class="st0" d="M801.8,506.4l0.2-0.7l0.5,0.1l-5.9,108.4l-2.3-3.1l-1.8,3.1l2.2-40.3h0.5l0.1-4.1H795l3.6-66.5l0.7,0.7
	L801.8,506.4z"/>
<path class="st1" d="M800.3,278.3l-60,94.7l0.5,0.2l-43.7,117.1l-168.8-9.4c-1.8-3.6-8.1-15.6-14.5-27.6c-4.5-8.3-8.2-15-11.1-19.7
	c-4-6.7-5.8-8.9-7-9.6l-7.7-10.1L544.5,298L476,235.7l1.2-25.1c9.1-2.4,59.6-10.7,99.7-17.1c3,3.7,18.3,23.1,33.8,42.3
	c10,12.5,18.1,22.5,24,29.7c11.5,14,12,14.2,12.7,14.4c0.2,0.1,0.5,0.1,0.7,0.1c1.1,0,2.2-0.9,3.8-2.5c1.3-1.3,3.1-3.2,5.3-5.6
	c3.7-4.1,8.7-9.9,14.9-17.2c8.6-10.2,17.2-20.5,20-23.9L800.3,278.3z"/>
<path class="st0" d="M798.7,499.4l-0.2,4.1c-1.5-1.3-5-4.5-8.6-7.9c-9.8-9.2-10.1-10.7-10.4-11.5s-0.5-2.2,3.5-18.4
	c1.5-5.8,3-11.6,3.7-14l-26.4-21l0.1-1.1c1.2-9.4,5-38.8,6.7-45.2c-1.8-1.5-9.3-5-22.5-9.8l0.7-1.9l-3.8-1.4l-0.7,2l-0.5-0.2
	l60-94.8l2.2,1l0.2,0.1l1.6,0.4L746.6,371c23.2,8.4,24.2,11,24.7,12.1c0.3,0.7,0.3,1.4-0.1,2.1c-1,2.4-4.4,27.7-6.5,43.8l26.7,21.2
	l-0.3,1.3c-3.7,13.7-7.5,29.1-7.5,31.6c1,1.8,8.4,9,15.8,15.7l-0.4,0.7L798.7,499.4z"/>
<path class="st1" d="M798.5,503.5l-3.6,66.5l-60.8-1.4l-16.6,9.9l-27.6-13.8l-0.4,0.8l11-72.6l44.1-118.4
	c13.2,4.8,20.6,8.3,22.5,9.8c-1.7,6.4-5.5,35.8-6.7,45.2l-0.1,1.1l26.4,21c-0.7,2.5-2.2,8.2-3.7,14c-4,16.1-3.7,17.5-3.5,18.4
	s0.6,2.3,10.4,11.5C793.4,498.9,797,502.1,798.5,503.5z"/>
<polygon class="st0" points="796.5,614.2 796.5,615 792.4,614.8 792.4,614.3 794.2,611.2 "/>
<polygon class="st0" points="795.2,570 795.1,574 794.6,574 794.8,570 "/>
<polygon class="st0" points="794.8,570 794.6,574 735.1,572.7 717.6,583.2 689,568.9 689.5,565.5 689.9,564.7 717.5,578.5
	734,568.6 "/>
<path class="st1" d="M794.6,574l-2.2,40.2l-20.3,35.2l-0.8,3.6v-1.5c0-1.6,0.4-11.3,0.7-16.2l0.1-2.1l-27.7-0.8l-2.6,18.9l29.4,2.4
	l-12.4,55.7l-47.5,2.6h-0.5L675,733.6l0.4,0.6l-54.5-34.3L688,574.3l0.2-0.3l0.8-5.2l28.7,14.3l17.5-10.5L794.6,574z"/>
<path class="st0" d="M772.1,633.3l-0.1,2.1c-0.2,4.9-0.7,14.7-0.7,16.2v1.5l-0.2,0.7l-29.4-2.4l2.6-18.9L772.1,633.3z M767.8,637.3
	l-19.9-0.6l-1.5,11l20.9,1.7C767.4,646.1,767.7,640.4,767.8,637.3L767.8,637.3z"/>
<polygon class="st0" points="771.3,653.1 771.3,653.8 771.1,653.8 "/>
<path class="st1" d="M747.9,636.7l19.9,0.6c-0.2,3.1-0.4,8.8-0.5,12.1l-20.9-1.7L747.9,636.7z"/>
<path class="st0" d="M745.3,372.7l-0.7,1.9l0,0l-1.8-0.7l-2-0.7l0.7-2L745.3,372.7z"/>
<path class="st0" d="M744.6,374.5l-44.1,118.4l0.4-2.4l-3.7-0.2l43.7-117.1l2,0.7L744.6,374.5L744.6,374.5z"/>
<path class="st1" d="M668.2,132.9l33.5,67l-11.8,27.4c-13.9,16.8-36.1,43.2-41.6,48.2c-6.6-7.2-42-51.5-66.8-82.7
	c25.6-4.1,45.9-7.2,46.5-7.3l0.8-0.1L668.2,132.9z"/>
<polygon class="st0" points="700.8,490.5 700.5,492.9 700.4,493.1 696.6,491.7 697.1,490.3 "/>
<path class="st0" d="M700.4,493.1l0.1-0.2l-11,72.6l-1.4,2.9l0.9,0.5l-0.8,5.1l-0.2,0.3l-67.2,125.6l-1.6-1l-2.2,3.5l0.5,0.3
	l-106.3-4l0.1-2.5l-0.7-1.6l106.3,4l67.3-125.8l11.9-78.4l-170.4-9.5l-0.5-1c-12-23.5-26-49.2-30.6-55.1c-1,2.4-2.6,8-4.4,17.6
	c-1.9,10.1-2.5,17.3-2.4,19.1c0.3,0.4,0.4,1,0.4,1.5c-0.3,1.7-1.9,1.8-2.8,1.8c-0.6,0-1.5,0.1-2.6,0.1c-2.1,0-5.2,0.1-9.1,0.1
	c-6.7,0-16,0-27.6,0c-16.3-0.1-32.7-0.2-38.2-0.2c0-0.6,0.1-1.3,0.1-1.9l0.1-1.3l-1.6-0.9c27.6,0.2,67.7,0.4,77.4,0.2
	c0-0.9,0-1.9,0.1-3.2c0.2-2.8,0.7-6.7,1.4-11c1-6.2,2.3-12.5,3.5-17.1c0.6-2.8,1.5-5.4,2.8-7.9l1.1,1.4l3.2-2.5l-0.4-0.5
	c1.2,0.7,3,2.9,7,9.6c2.9,4.8,6.6,11.4,11.1,19.7c6.5,12,12.7,24,14.5,27.6l168.8,9.4l-0.5,1.4L700.4,493.1z"/>
<path class="st1" d="M696.1,494.3l-11.9,78.4L617,698.5l-106.3-4l-16.3-36.7l-46-5.4c-0.9-4.1-3.8-16.4-7-28.6
	c-2.3-8.7-4.3-15.7-5.9-20.7c-1.8-5.3-3-8.1-4.1-9.5l17.9-65.5l-2.3-0.3c-13.6-2-35.6-5.4-39.8-6.5c-1.3-4.3-0.8-29.4,0.6-52.7
	c5.5,0,21.9,0.2,38.2,0.2c11.7,0.1,21,0.1,27.6,0c4,0,7,0,9.1-0.1c1.2,0,2,0,2.6-0.1c1,0,2.5-0.1,2.8-1.8c0.1-0.5,0-1.1-0.4-1.5
	c-0.2-1.8,0.5-9,2.4-19.1c1.8-9.6,3.4-15.2,4.4-17.6c4.6,5.9,18.6,31.7,30.6,55.1l0.5,1L696.1,494.3z"/>
<path class="st0" d="M690.1,227.1l3.2,2.6l-1,1.2l-3.3-1.4l0.9-2.1L690.1,227.1z"/>
<path class="st0" d="M689,229.4l3.3,1.4c-2.8,3.4-11.4,13.8-20,23.9c-6.2,7.3-11.2,13-14.9,17.2c-2.2,2.5-4,4.4-5.3,5.6
	c-1.7,1.6-2.7,2.5-3.8,2.5c-0.2,0-0.5,0-0.7-0.1c-0.8-0.3-1.3-0.4-12.7-14.4c-5.9-7.2-14-17.2-24-29.7
	c-15.4-19.2-30.8-38.6-33.8-42.3l4.6-0.7c24.8,31.2,60.2,75.4,66.8,82.7c5.5-5,27.7-31.3,41.6-48.2L689,229.4z"/>
<polygon class="st0" points="689.5,565.5 689,568.9 688,568.4 "/>
<polygon class="st0" points="678.6,736.2 677.1,737.1 675.3,734.2 "/>
<path class="st1" d="M675.9,739.3l-49.2,75.1l-1.6,2l0,0l-28.3,35.9h-18.3l-25.7-41.9l-44.1-10.7l2.6-101.1l106.3,4L675.9,739.3z"/>
<polygon class="st0" points="671.5,753.6 668.7,757.8 668.6,757.8 668.5,753.7 "/>
<path class="st0" d="M630,816.9l-1.7,2.1c0.4-0.5,0.5-1.1,0.3-1.6c-0.1-0.5-0.4-0.9-0.8-1.1C628.6,816.5,629.3,816.7,630,816.9
	L630,816.9z"/>
<path class="st0" d="M628.3,819l-1,1.3c-1.4-0.4-2.1-0.8-2.5-1.7c-0.3-0.7-0.2-1.5,0.3-2.2l0,0L628.3,819z"/>
<path class="st0" d="M627.3,820.3l-27.6,35l0.6-2.9h-3.5l28.3-35.9c-0.5,0.6-0.6,1.4-0.3,2.2C625.2,819.5,625.8,819.9,627.3,820.3z"
	/>
<polygon class="st0" points="619.3,698.9 620.9,699.9 619.4,702.7 617.6,702.6 617.1,702.3 "/>
<path class="st0" d="M627.9,816.2c0.4,0.3,0.7,0.7,0.8,1.1c0.1,0.6,0,1.2-0.3,1.6l0,0l-3.2-2.5l1.6-2l49.2-75.1l-58.3-36.7l1.8,0.1
	l1.5-2.8l54.5,34.3l1.7,2.9l1.5-0.9l3,1.9l-10.1,15.5l-3,0.1l0.2,4.1h0.1l-38.7,59C629.3,816.7,628.6,816.5,627.9,816.2z"/>
<polygon class="st0" points="600.3,852.4 599.7,855.3 599.4,855.7 596.2,853.1 596.8,852.4 "/>
<path class="st0" d="M579.6,190.3l1.9,2.4l-4.6,0.7l-0.5-0.6L579.6,190.3z"/>
<path class="st0" d="M544.5,298l-56.6,115.9l7.7,10.1c-0.4-0.2-0.8-0.3-1.3-0.3c-1,0-1.9,0.5-2.7,1.9l-8.5-11.2L539.5,299
	l-66.3-60.4l2.7-0.1l0.1-2.9L544.5,298z"/>
<path class="st1" d="M539.5,298.9l-56.4,115.4l8.5,11.2c-1.3,2.5-2.2,5.2-2.8,7.9c-1.2,4.6-2.5,10.9-3.5,17.1
	c-0.7,4.2-1.2,8.1-1.4,11c-0.1,1.2-0.2,2.3-0.1,3.2c-9.6,0.2-49.8,0-77.4-0.2l-47.1-25l-1.1,1c-12.6,12.3-27.1,25.9-29.7,27.4
	c-1.2,0.2-5.8,1.6-28.9,9.9c-13.5,4.9-27,9.8-27.1,9.9l0.8,2.3L95.5,419.8c2.9-5,7.4-12.1,14.5-22.6c8.7-12.9,17.5-25.3,19.5-28.1
	l64.9-16.6l-6.8-119l57.8-42c3.1,2.3,11.7,8.7,20.4,15.6c19,14.9,22,19,22.5,19.9c-0.1,0.5,0.1,1.1,0.4,1.5c0.5,0.6,1.2,1,2,1l0,0
	c1.1,0,3.9,0,36.8-16.7c16.1-8.2,31.7-16.4,31.9-16.5l0.8-0.4l0,0c2.1-0.8,8.7-1.3,14.8-1.4l10.1,76l20.5,15.2l42.8-46.3l24.9-0.6
	L539.5,298.9z"/>
<polygon class="st0" points="510.7,694.5 511.4,696.1 511.3,698.7 509.2,698.6 509.4,694.5 "/>
<path class="st0" d="M495.6,424l0.4,0.5l-3.2,2.5l-1.1-1.4c0.8-1.3,1.7-1.9,2.7-1.9C494.8,423.7,495.2,423.8,495.6,424z"/>
<path class="st0" d="M477.3,209.4l-0.1,1.2H477c-0.4,0.5-1.1,0.7-1.7,0.7c-0.2,0-0.4,0-0.6-0.1c-0.7-0.2-1.3-0.7-1.6-1.4v-0.7
	L477.3,209.4z"/>
<path class="st0" d="M477.3,210.6l-1.3,25.1l-0.7-0.6l-2.7,3l0.6,0.6l-24.9,0.6l-42.8,46.3L385,270.4l-10.1-76
	c-6.1,0.1-12.7,0.6-14.8,1.4l1.1-0.6l-1.9-3.4c4.5-1.3,13.4-1.5,17.5-1.5h1.8l10.3,77.8l16.2,12l41.5-44.9l25.5-0.7l1.2-24.6
	c0.2,0.7,0.8,1.2,1.6,1.4c0.2,0.1,0.4,0.1,0.6,0.1C476.1,211.4,476.7,211.1,477.3,210.6L477.3,210.6z"/>
<polygon class="st0" points="476,235.7 475.9,238.5 473.2,238.6 472.6,238 475.3,235 "/>
<path class="st1" d="M473.2,209.9l-1.2,24.6l-25.5,0.7L405,280.1l-16.2-12l-10.3-77.8h-1.8c-4.1,0-13,0.2-17.5,1.5l-29.4-51.4
	l43.7,11.2l0.7-0.4c2.3-1.3,49.4-27.4,64.9-36.5l-0.1,0.4l1.8-1.2c1.4,6.2,6.2,19.4,16.3,46.2c6.8,18,15.9,42.3,16.6,47.7
	c-0.4,0.4-0.6,1-0.6,1.5C473.2,209.5,473.2,209.7,473.2,209.9z"/>
<path class="st0" d="M449.3,528.1l-17.9,65.5c-0.5-0.8-1.3-1.2-2.2-1.3c-0.5-0.1-1-0.3-1.5-0.4l16.5-60.5c-9.5-1.4-35.9-5.3-39-6.6
	c-1.6-0.7-2.5-2.5-2.7-11.2c-0.1-4.8-0.1-11.3,0.2-19.5c0.3-11.3,1-22.7,1.2-26.5L360,444.5c-2.3,2.2-7.8,7.6-13.5,12.9
	c-14.8,13.9-16.3,14.5-17.4,14.5c-2.9,0.6-32.9,11.4-53.5,19l-2.3-0.9l-0.8-2.3c0.1,0,13.6-5,27.1-9.9c23.1-8.3,27.6-9.7,28.9-9.9
	c2.5-1.5,17.1-15.1,29.7-27.4l1.1-1l47.1,25h-0.5v4.1h1.9c-1.4,23.3-2,48.4-0.6,52.7c4.2,1.1,26.2,4.5,39.8,6.5L449.3,528.1z"/>
<path class="st1" d="M444.1,531.5L427.6,592c-6.4-2.1-29-10.9-49.2-18.9c-40.8-16-59.8-23.3-64.3-24.2c-0.6-1.2-2.2-7-2.1-33
	c0.1-15.3,0.7-30.1,0.7-30.2l0.1-3.6l-25,13.7l-12.2-4.8c20.6-7.6,50.6-18.4,53.5-19c1.1,0,2.6-0.6,17.3-14.5
	c5.7-5.3,11.2-10.7,13.5-12.9l43.8,23.2c-0.2,3.8-0.9,15.1-1.2,26.5c-0.2,8.1-0.3,14.7-0.2,19.5c0.3,8.7,1.1,10.6,2.7,11.2
	C408.3,526.2,434.7,530.1,444.1,531.5z"/>
<path class="st0" d="M431.4,593.7L431,595l-3.9-1.1l0.5-1.9c0.5,0.2,1,0.3,1.5,0.4C430,592.5,430.9,592.9,431.4,593.7z"/>
<path class="st0" d="M595.3,856.4h-19.1l-26-42.4l-45.7-11.1l2.8-106l-15.7-35.3l-46.6-5.5l-0.3-1.4c0-0.1-3.2-13.9-6.8-28
	c-6.3-24.2-8.8-29.3-9.6-30.3c-3.5-0.8-16.6-5.8-51.4-19.5c-25.4-10-60.2-23.7-63.6-24c-0.8,0-1.5-0.4-2-0.9
	c-1-1.1-3.5-3.6-3.4-35.7c0-11,0.4-21.8,0.5-27.2L226.5,534l-53.1-12.9l10.3-47.5l-39.6,25.5l-1.1-1.4c-0.1-0.1-12.4-15.8-25.3-31.5
	c-23.7-28.9-28.5-32.7-29.4-33.1c-0.8-0.2-1.5-0.8-1.7-1.6c-0.6-1.6-1.6-4.3,19.4-35.6c10.1-15.1,20.6-29.7,20.7-29.9l0.4-0.6
	l63-16.1l-6.8-117.8l62-45.1l1.2,0.9c0.1,0.1,11.7,8.6,23,17.6c6.7,5.3,11.9,9.6,15.6,13c3.9,3.5,5.8,5.6,6.6,7.2
	c7.6-2.4,41.5-19.8,63.7-31.5l-34-59.5l51.5,13.2c6.9-3.8,60.9-33.9,67.9-38.4c0.3-0.4,0.7-0.7,1.1-0.8h0.1l3.7-2.6l-1.1,4
	c0.2,0.6,0.1,1.3-0.4,1.8c0.4,4.8,9.7,29.3,16.5,47.4c10.7,28.4,15.5,41.8,16.7,47.7c20.5-4.8,137-22.9,149-24.8l42.3-56.4
	l37.3,74.6l-11.8,27.6l109.6,48.1l110,27.7l-0.1,0.3l-2.3,3.4l-107.3-27.1l0.8-1.2l-3.5-2.2l-1.3,2l-108-47.4l1-1.2l-3.2-2.6
	l-0.2,0.2l11.8-27.4L668,133l-39.3,52.4l-0.8,0.1c-0.5,0.1-20.8,3.2-46.5,7.3l-1.9-2.4l-3.2,2.5l0.5,0.6
	c-40.1,6.4-90.6,14.6-99.7,17.1l0.1-1.2l-4.1-0.2v0.7c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.6,0.2-1.1,0.6-1.5c-0.7-5.4-9.9-29.7-16.6-47.7
	c-10.1-26.8-14.9-40-16.3-46.2l-1.8,1.3l0.1-0.4c-15.5,9.1-62.6,35.3-64.9,36.5l-0.7,0.4l-43.7-11.2l29.4,51.4
	c-0.7,0.2-1.5,0.5-2.1,0.9l2.4,3.3c0.2-0.1,0.3-0.2,0.5-0.2l-0.8,0.4c-0.2,0.1-15.8,8.3-31.9,16.5c-32.9,16.7-35.6,16.7-36.8,16.7
	l0,0c-0.8,0-1.5-0.4-2-1c-0.3-0.4-0.5-1-0.4-1.5c-0.5-0.9-3.5-5-22.5-19.9c-8.7-6.8-17.3-13.3-20.4-15.6l-57.8,42l6.8,119L129.5,369
	c-2,2.8-10.8,15.2-19.5,28.1c-7,10.5-11.6,17.7-14.5,22.6l-1.8-0.8l-1.5,3.8l1.3,0.5c-1.2,2-2.2,4.1-3,6.3
	c2.3,1.5,8.5,7.4,29.9,33.4c10.8,13.2,21.3,26.4,24.7,30.7l44.8-28.9l-11.5,53.2l47.7,11.6l57.2-31.4l3.6,1.4l1.5-3.8l-0.4-0.2
	l25-13.7l-0.1,3.6c0,0.1-0.6,15-0.7,30.2c-0.1,26.1,1.5,31.8,2.1,33c4.6,0.8,23.5,8.1,64.3,24.2c20.2,7.9,42.8,16.8,49.2,18.9
	l-0.5,1.9l3.9,1.1l0.4-1.3c1.1,1.4,2.3,4.2,4.1,9.5c1.6,5,3.6,12,5.9,20.7c3.2,12.2,6.1,24.5,7,28.6l46,5.4l16.3,36.7h-1.3l-0.1,4.1
	l2.1,0.1L509,799.6l44.1,10.7l25.7,41.9h18.3l-0.6,0.8l3.2,2.5l0.3-0.4"/>
<path class="st0" d="M408,465.3l-0.1,1.3c0,0.6-0.1,1.3-0.1,1.9h-1.9v-4.1h0.5L408,465.3z"/>
<path class="st0" d="M359.1,191.8l1.9,3.4l-1.1,0.6l0,0c-0.2,0.1-0.4,0.1-0.5,0.2l-2.5-3.3C357.7,192.3,358.4,192,359.1,191.8z"/>
<polygon class="st0" points="288.2,495.9 286.7,499.7 283.1,498.3 287.8,495.8 "/>
<path class="st0" d="M275.6,491l12.2,4.8l-4.6,2.5l-189.7-75c0.6-1,1.2-2.2,2-3.6L273.4,490l0.6,1.5L275.6,491z"/>
<path class="st1" d="M283.1,498.3L226,529.7l-47.6-11.6l11.5-53.2L145,493.8c-3.4-4.3-13.9-17.5-24.7-30.7
	c-21.4-26-27.5-31.9-29.8-33.3c0.8-2.2,1.8-4.3,3-6.3L283.1,498.3z"/>
<path class="st0" d="M273.3,490l2.3,0.9l-1.7,0.6L273.3,490z"/>
<path class="st0" d="M93.6,419l1.8,0.7c-0.8,1.4-1.5,2.5-2,3.6l-1.3-0.5L93.6,419z"/>
<polygon class="st0" points="922.2,466.5 940.6,433.1 941.1,429.8 941.4,432.1 945.5,431.5 924.6,468.5 "/>
<polygon class="st0" points="677.1,737.1 674.7,733.8 710.1,710.2 757.1,707.6 769.4,650.8 792.8,613.8 796.5,615 773.2,652.4
	760.4,711.5 711.5,714.2 "/>
<g @click="mostarIntervencao(23)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(23)">
	<circle class="st2" cx="743.8" cy="615.8" r="14.5"/>
	<circle class="st3" cx="743.8" cy="615.8" r="13"/>
	<circle class="st4" cx="743.8" cy="615.8" r="11.7"/>
	<path class="st5" d="M743.8,628.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C756.2,622.7,750.6,628.2,743.8,628.2z M743.8,604.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C754.9,609.7,749.9,604.7,743.8,604.7L743.8,604.7z"/>
	<path class="st6" d="M751.3,615.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.5c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-1l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C751.6,615.5,751.5,615.4,751.3,615.4L751.3,615.4z M744.2,611.6h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0H747h-0.2l-1.7-0.3h-0.9L744.2,611.6z M737.9,620.8h-1.4v-4.9h1.4
		V620.8z M743.2,610.7h0.6v0.3h-0.6V610.7z M743.2,611.6h0.6v0.6h-0.6V611.6z M743.2,612.6h0.6v1.7h-0.6V612.6z M741.8,612.2
		L741.8,612.2l-1.7,0.3H740c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H741.8z M742.1,614.8
		h2.8v1.1h-2.8V614.8z M738.4,617h1.8v2.8h-1.8V617z M746.2,620.3h-5.5v-3.8h5.5V620.3z M749.2,619.8h-2.5V617h2.5V619.8z
		 M751.1,620.8h-1.4v-4.9h1.4V620.8z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(27)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(27)">
	<circle class="st2" cx="768.8" cy="617.7" r="14.5"/>
	<circle class="st3" cx="768.8" cy="617.7" r="13"/>
	<circle class="st4" cx="768.8" cy="617.7" r="11.7"/>
	<path class="st5" d="M768.8,630.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C781.2,624.6,775.7,630.1,768.8,630.1z M768.8,606.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C779.9,611.6,774.9,606.6,768.8,606.6L768.8,606.6z"/>
	<path class="st6" d="M776.4,617.3h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V618c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.6h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C776.6,617.4,776.5,617.3,776.4,617.3L776.4,617.3z M769.3,613.5h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		s-0.2,0.7-0.5,0.8l0,0h-0.1H772l-1.7-0.3h-0.9L769.3,613.5z M762.9,622.7h-1.4v-4.9h1.4V622.7z M768.2,612.6h0.6v0.3h-0.6V612.6z
		 M768.2,613.5h0.6v0.6h-0.6V613.5z M768.2,614.5h0.6v1.7h-0.6V614.5z M766.9,614.1L766.9,614.1l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H766.9z M767.1,616.7h2.8v1.1h-2.8V616.7z
		 M763.4,618.9h1.8v2.8h-1.8V618.9z M771.3,622.2h-5.5v-3.9h5.5V622.2z M774.3,621.6h-2.5v-2.8h2.5V621.6z M776.2,622.7h-1.4v-4.9
		h1.4V622.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(17)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(17)">
	<circle class="st2" cx="741.8" cy="488" r="14.5"/>
	<circle class="st3" cx="741.8" cy="488" r="13"/>
	<circle class="st4" cx="741.8" cy="488" r="11.7"/>
	<path class="st5" d="M741.8,500.4c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C754.2,494.8,748.6,500.4,741.8,500.4z M741.8,476.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C752.8,481.9,747.9,476.9,741.8,476.9L741.8,476.9z"/>
	<path class="st6" d="M749.3,487.6h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H740l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C749.6,487.7,749.4,487.6,749.3,487.6L749.3,487.6z M742.2,483.7h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H745h-0.1l-1.7-0.3h-0.9L742.2,483.7z M735.8,493h-1.4v-4.9h1.4V493z M741.1,482.9h0.6v0.3h-0.6V482.9
		z M741.1,483.7h0.6v0.6h-0.6V483.7z M741.1,484.8h0.6v1.7h-0.6V484.8z M739.8,484.3L739.8,484.3l-1.7,0.3H738
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L739.8,484.3z M740,487h2.8v1.1H740V487z
		 M736.3,489.1h1.8v2.8h-1.8V489.1z M744.2,492.5h-5.5v-3.9h5.5V492.5z M747.2,491.9h-2.5v-2.8h2.5V491.9z M749.1,493h-1.4v-4.9h1.4
		V493z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(22)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(22)">
	<circle class="st2" cx="731.8" cy="636.1" r="14.5"/>
	<circle class="st3" cx="731.8" cy="636.1" r="13"/>
	<circle class="st4" cx="731.8" cy="636.1" r="11.7"/>
	<path class="st5" d="M731.8,648.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C744.2,642.9,738.7,648.5,731.8,648.5z M731.8,625c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C742.9,630,737.9,625,731.8,625L731.8,625z"/>
	<path class="st6" d="M739.4,635.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.6v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H730l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C739.6,635.8,739.5,635.7,739.4,635.7L739.4,635.7z M732.3,631.8h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H735l-1.7-0.3h-0.9L732.3,631.8z M725.9,641.1h-1.4v-4.9h1.4
		V641.1z M731.2,631h0.6v0.3h-0.6V631z M731.2,631.8h0.6v0.6h-0.6V631.8z M731.2,632.9h0.6v1.7h-0.6V632.9z M729.9,632.4
		L729.9,632.4l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H729.9z M730.1,635.1
		h2.8v1.1h-2.8V635.1z M726.4,637.2h1.8v2.8h-1.8V637.2z M734.3,640.6h-5.5v-3.9h5.5V640.6z M737.3,640h-2.5v-2.8h2.5V640z
		 M739.2,641.1h-1.5v-4.9h1.4L739.2,641.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(26)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(26)">
	<circle class="st2" cx="740.7" cy="660.1" r="14.5"/>
	<circle class="st3" cx="740.7" cy="660.1" r="13"/>
	<circle class="st4" cx="740.7" cy="660.1" r="11.7"/>
	<path class="st5" d="M740.7,672.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C753.2,667,747.6,672.6,740.7,672.6z M740.7,649.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C751.8,654,746.9,649.1,740.7,649.1L740.7,649.1z"/>
	<path class="st6" d="M748.3,659.8h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8V657h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H739l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8V660c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0V660C748.5,659.9,748.4,659.8,748.3,659.8L748.3,659.8z M741.2,655.9h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0H744h-0.1l-1.7-0.3h-0.9L741.2,655.9z M734.8,665.2h-1.4v-5h1.4V665.2z
		 M740.1,655.1h0.6v0.3h-0.6V655.1z M740.1,655.9h0.6v0.6h-0.6V655.9z M740.1,657h0.6v1.7h-0.6V657z M738.8,656.5L738.8,656.5
		l-1.7,0.3H737c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H738.8z M739,659.2h2.8v1.1H739
		V659.2z M735.3,661.3h1.8v2.8h-1.8V661.3z M743.2,664.7h-5.5v-3.9h5.5V664.7z M746.2,664.1h-2.5v-2.8h2.5V664.1z M748.1,665.2h-1.4
		v-5h1.4V665.2z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(16)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(16)">
	<circle class="st2" cx="925.3" cy="325.4" r="14.5"/>
	<circle class="st3" cx="925.3" cy="325.4" r="13"/>
	<circle class="st4" cx="925.3" cy="325.4" r="11.7"/>
	<path class="st5" d="M925.3,337.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C937.7,332.3,932.1,337.8,925.3,337.8z M925.3,314.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C936.3,319.3,931.4,314.3,925.3,314.3L925.3,314.3z"/>
	<path class="st6" d="M932.8,325h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V320
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4H922c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H920v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C933.1,325.1,933,325,932.8,325L932.8,325z M925.7,321.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L925.7,321.2z M919.4,330.4H918v-4.9h1.4V330.4z M924.6,320.3h0.6v0.3h-0.6
		V320.3z M924.6,321.2h0.6v0.6h-0.6V321.2z M924.6,322.2h0.6v1.7h-0.6V322.2z M923.3,321.7L923.3,321.7l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L923.3,321.7z M923.6,324.4h2.8v1.1h-2.8V324.4z
		 M919.9,326.6h1.8v2.8h-1.8V326.6z M927.7,329.9h-5.5V326h5.5V329.9z M930.7,329.3h-2.5v-2.8h2.5V329.3z M932.6,330.4h-1.4v-4.9
		h1.4V330.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(11)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(11)">
	<circle class="st2" cx="855.8" cy="301.3" r="14.5"/>
	<circle class="st3" cx="855.8" cy="301.3" r="13"/>
	<circle class="st4" cx="855.8" cy="301.3" r="11.7"/>
	<path class="st5" d="M855.8,313.8c-6.9,0-12.4-5.6-12.4-12.4S849,289,855.8,289c6.9,0,12.4,5.6,12.4,12.4l0,0
		C868.2,308.2,862.6,313.8,855.8,313.8z M855.8,290.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C866.9,295.2,861.9,290.3,855.8,290.3L855.8,290.3z"/>
	<path class="st6" d="M863.3,301h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V296
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H854l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C863.6,301.1,863.5,301,863.3,301L863.3,301z M856.2,297.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H859h-0.1l-1.7-0.3h-0.9L856.2,297.1z M849.9,306.4h-1.4v-4.9h1.4V306.4z M855.2,296.3h0.6v0.3h-0.6
		V296.3z M855.2,297.1h0.6v0.6h-0.6V297.1z M855.2,298.2h0.6v1.7h-0.6V298.2z M853.8,297.7L853.8,297.7l-1.7,0.3H852
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L853.8,297.7z M854.1,300.4h2.8v1.1h-2.8V300.4z
		 M850.4,302.5h1.8v2.8h-1.8V302.5z M858.2,305.8h-5.5V302h5.5V305.8z M861.2,305.3h-2.5v-2.8h2.5V305.3z M863.1,306.4h-1.4v-4.9
		h1.4V306.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(8)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(8)">
	<circle class="st2" cx="741.7" cy="269.3" r="14.5"/>
	<circle class="st3" cx="741.7" cy="269.3" r="13"/>
	<circle class="st4" cx="741.7" cy="269.3" r="11.7"/>
	<path class="st5" d="M741.7,281.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C754.1,276.2,748.6,281.7,741.7,281.7z M741.7,258.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C752.8,263.2,747.8,258.3,741.7,258.3L741.7,258.3z"/>
	<path class="st6" d="M749.3,268.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V268
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V264
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6H740l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C749.5,269,749.4,268.9,749.3,268.9L749.3,268.9z M742.2,265.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H745h-0.1l-1.7-0.3h-0.9L742.2,265.1z M735.8,274.4h-1.4v-4.9h1.4V274.4z M741.1,264.3h0.6v0.3h-0.6
		V264.3z M741.1,265.1h0.6v0.6h-0.6V265.1z M741.1,266.2h0.6v1.7h-0.6V266.2z M739.8,265.7L739.8,265.7L738,266h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L739.8,265.7z M740,268.3h2.8v1.1H740V268.3z
		 M736.3,270.5h1.8v2.8h-1.8V270.5z M744.1,273.8h-5.5V270h5.5V273.8z M747.1,273.3h-2.5v-2.8h2.5V273.3z M749,274.3h-1.4v-4.9h1.4
		V274.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(6)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st2" cx="660.3" cy="231.6" r="14.5"/>
	<circle class="st3" cx="660.3" cy="231.6" r="13"/>
	<circle class="st4" cx="660.3" cy="231.6" r="11.7"/>
	<path class="st5" d="M660.3,244.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C672.7,238.5,667.2,244.1,660.3,244.1z M660.3,220.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C671.4,225.5,666.4,220.6,660.3,220.6L660.3,220.6z"/>
	<path class="st6" d="M667.9,231.3H666c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V232c0-0.1-0.1-0.2-0.2-0.2l0,0H662v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0H661v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3H661v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4H657c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H655v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C668.1,231.4,668,231.3,667.9,231.3L667.9,231.3z M660.8,227.4h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		s-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L660.8,227.4z M654.4,236.7H653v-4.9h1.4V236.7z M659.7,226.6h0.6v0.3h-0.6V226.6z
		 M659.7,227.4h0.6v0.6h-0.6V227.4z M659.7,228.5h0.6v1.7h-0.6V228.5z M658.3,228L658.3,228l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H658.3z M658.6,230.7h2.8v1.1h-2.8V230.7z M654.9,232.8h1.8v2.8h-1.8
		V232.8z M662.7,236.1h-5.5v-3.9h5.5V236.1z M665.7,235.6h-2.5v-2.8h2.5V235.6z M667.6,236.7h-1.4v-4.9h1.4V236.7z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(9)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(9)">
	<circle class="st2" cx="703.2" cy="372.8" r="14.5"/>
	<circle class="st3" cx="703.2" cy="372.8" r="13"/>
	<circle class="st4" cx="703.2" cy="372.8" r="11.7"/>
	<path class="st5" d="M703.2,385.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C715.6,379.7,710,385.2,703.2,385.2z M703.2,361.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C714.2,366.7,709.3,361.8,703.2,361.8L703.2,361.8z"/>
	<path class="st6" d="M710.7,372.4h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C711,372.5,710.9,372.4,710.7,372.4L710.7,372.4z M703.6,368.6h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L703.6,368.6z M697.3,377.9h-1.4V373h1.4V377.9z M702.5,367.8h0.6v0.3h-0.6
		V367.8z M702.5,368.6h0.6v0.6h-0.6V368.6z M702.5,369.7h0.6v1.7h-0.6V369.7z M701.2,369.2L701.2,369.2l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L701.2,369.2z M701.5,371.8h2.8v1.1h-2.8V371.8z
		 M697.8,374h1.8v2.8h-1.8V374z M705.6,377.3h-5.5v-3.9h5.5V377.3z M708.6,376.8h-2.5V374h2.5V376.8z M710.5,377.9h-1.4V373h1.4
		V377.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(3)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(3)">
	<circle class="st2" cx="365.1" cy="474.1" r="14.5"/>
	<circle class="st3" cx="365.1" cy="474.1" r="13"/>
	<circle class="st4" cx="365.1" cy="474.1" r="11.7"/>
	<path class="st5" d="M365.1,486.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C377.5,480.9,371.9,486.5,365.1,486.5z M365.1,463c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C376.1,468,371.2,463,365.1,463L365.1,463z"/>
	<path class="st6" d="M372.6,473.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H368v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0H358c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C372.9,473.8,372.7,473.7,372.6,473.7L372.6,473.7z M365.5,469.8h0.8c0,0,0,0,0.1,0
		l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L365.5,469.8z M359.1,479.1h-1.4v-4.9h1.4
		V479.1z M364.4,469h0.6v0.3h-0.6V469z M364.4,469.8h0.6v0.6h-0.6V469.8z M364.4,470.9h0.6v1.7h-0.6V470.9z M363.1,470.4
		L363.1,470.4l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L363.1,470.4z
		 M363.3,473.1h2.8v1.1h-2.8V473.1z M359.6,475.2h1.8v2.8h-1.8V475.2z M367.5,478.6H362v-3.9h5.5V478.6z M370.5,478H368v-2.8h2.5
		V478z M372.4,479.1H371v-4.9h1.4V479.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(28)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st2" cx="713.6" cy="682.8" r="14.5"/>
	<circle class="st3" cx="713.6" cy="682.8" r="13"/>
	<circle class="st4" cx="713.6" cy="682.8" r="11.7"/>
	<path class="st5" d="M713.6,695.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C726,689.6,720.5,695.2,713.6,695.2z M713.6,671.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C724.7,676.7,719.7,671.7,713.6,671.7L713.6,671.7z"/>
	<path class="st6" d="M713.6,682.8L713.6,682.8L713.6,682.8z"/>
	<g>
		<g>
			<g>
				<path d="M717.6,677.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2V679
					C718.9,678.3,718.3,677.7,717.6,677.7z M711.5,677.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L711.5,677.6L711.5,677.6z M718.3,688.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					V679c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L718.3,688.4L718.3,688.4z"/>
				<path d="M712.3,683.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C712.5,683.6,712.5,683.4,712.3,683.2L712.3,683.2z"/>
				<path d="M717,683.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S717.2,683.9,717,683.9z"/>
				<path d="M712.3,680.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C712.5,681,712.5,680.8,712.3,680.6L712.3,680.6z"/>
				<path d="M717,681.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S717.2,681.3,717,681.3z"/>
				<path d="M712.3,685.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C712.5,686.2,712.5,686,712.3,685.8C712.3,685.9,712.3,685.8,712.3,685.8z
					"/>
				<path d="M717,686.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S717.2,686.5,717,686.5z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(30)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(30)">
	<circle class="st2" cx="762.8" cy="678.2" r="14.5"/>
	<circle class="st3" cx="762.8" cy="678.2" r="13"/>
	<circle class="st4" cx="762.8" cy="678.2" r="11.7"/>
	<path class="st5" d="M762.8,690.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C775.2,685,769.7,690.6,762.8,690.6z M762.8,667.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C773.9,672,768.9,667.1,762.8,667.1L762.8,667.1z"/>
	<path class="st6" d="M762.8,678.2L762.8,678.2L762.8,678.2z"/>
	<g>
		<g>
			<g>
				<path d="M766.8,673.1h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C768.2,673.7,767.6,673.1,766.8,673.1z M760.7,672.9h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L760.7,672.9L760.7,672.9z M767.5,683.8c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L767.5,683.8L767.5,683.8z"/>
				<path d="M761.6,678.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C761.7,678.9,761.7,678.7,761.6,678.6L761.6,678.6z"/>
				<path d="M766.2,679.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S766.4,679.3,766.2,679.3z"/>
				<path d="M761.6,676c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C761.7,676.3,761.7,676.1,761.6,676L761.6,676z"/>
				<path d="M766.2,676.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C766.6,676.8,766.4,676.7,766.2,676.7z"/>
				<path d="M761.6,681.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C761.7,681.5,761.7,681.3,761.6,681.2L761.6,681.2z"/>
				<path d="M766.2,681.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S766.4,681.9,766.2,681.9z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(24)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st2" cx="783.6" cy="640.9" r="14.5"/>
	<circle class="st3" cx="783.6" cy="640.9" r="13"/>
	<circle class="st4" cx="783.6" cy="640.9" r="11.7"/>
	<path class="st5" d="M783.6,653.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C796,647.8,790.5,653.3,783.6,653.3z M783.6,629.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C794.7,634.8,789.7,629.8,783.6,629.8L783.6,629.8z"/>
	<path class="st6" d="M783.6,640.9L783.6,640.9L783.6,640.9z"/>
	<g>
		<g>
			<g>
				<path d="M787.6,635.9h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C789,636.4,788.3,635.9,787.6,635.9z M781.5,635.7h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L781.5,635.7L781.5,635.7z M788.3,646.5c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L788.3,646.5L788.3,646.5z"/>
				<path d="M782.3,641.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C782.5,641.7,782.5,641.5,782.3,641.4
					C782.4,641.4,782.4,641.4,782.3,641.4z"/>
				<path d="M787,642.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3C787.4,642.2,787.2,642.1,787,642.1z
					"/>
				<path d="M782.3,638.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C782.5,639.1,782.5,638.9,782.3,638.7
					C782.4,638.8,782.4,638.8,782.3,638.7z"/>
				<path d="M787,639.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S787.2,639.4,787,639.4z"/>
				<path d="M782.3,644c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C782.5,644.3,782.5,644.1,782.3,644C782.4,644,782.4,644,782.3,644z"/>
				<path d="M787,644.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3C787.4,644.8,787.2,644.7,787,644.7z
					"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(25)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(25)">
	<circle class="st2" cx="676.5" cy="710.8" r="14.5"/>
	<circle class="st3" cx="676.5" cy="710.8" r="13"/>
	<circle class="st4" cx="676.5" cy="710.8" r="11.7"/>
	<path class="st5" d="M676.5,723.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C688.9,717.7,683.4,723.3,676.5,723.3z M676.5,699.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C687.6,704.7,682.6,699.8,676.5,699.8L676.5,699.8z"/>
	<path class="st6" d="M676.5,710.8L676.5,710.8L676.5,710.8z"/>
	<g>
		<g>
			<g>
				<path d="M680.5,705.8h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H674
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C681.9,706.4,681.3,705.8,680.5,705.8z M674.4,705.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L674.4,705.6L674.4,705.6z M681.3,716.5c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L681.3,716.5L681.3,716.5z"/>
				<path d="M675.3,711.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C675.4,711.6,675.4,711.4,675.3,711.3L675.3,711.3z"/>
				<path d="M679.9,712h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S680.1,712,679.9,712z"/>
				<path d="M675.3,708.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C675.4,709,675.4,708.8,675.3,708.7L675.3,708.7z"/>
				<path d="M679.9,709.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C680.3,709.5,680.1,709.4,679.9,709.4z"/>
				<path d="M675.3,713.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C675.4,714.2,675.4,714,675.3,713.9L675.3,713.9z"/>
				<path d="M679.9,714.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S680.1,714.6,679.9,714.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(20)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(20)">
	<circle class="st2" cx="571" cy="662.3" r="14.5"/>
	<circle class="st3" cx="571" cy="662.3" r="13"/>
	<circle class="st4" cx="571" cy="662.3" r="11.7"/>
	<path class="st5" d="M571,674.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C583.4,669.1,577.8,674.7,571,674.7z M571,651.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C582.1,656.2,577.1,651.2,571,651.2L571,651.2z"/>
	<path class="st6" d="M571,662.3L571,662.3L571,662.3z"/>
	<g>
		<g>
			<g>
				<path d="M575,657.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.8c-0.2,0-0.4,0.1-0.4,0.3
					v0.6H567c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C576.3,657.8,575.7,657.2,575,657.2z
					 M568.9,657.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L568.9,657.1L568.9,657.1z M575.7,667.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L575.7,667.9L575.7,667.9z"/>
				<path d="M569.7,662.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C569.8,663.1,569.9,662.9,569.7,662.7L569.7,662.7z"/>
				<path d="M574.4,663.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C574.7,663.6,574.6,663.4,574.4,663.4z"/>
				<path d="M569.7,660.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C569.8,660.5,569.9,660.3,569.7,660.1L569.7,660.1z"/>
				<path d="M574.4,660.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C574.7,661,574.6,660.8,574.4,660.8z"/>
				<path d="M569.7,665.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C569.8,665.7,569.9,665.5,569.7,665.3
					C569.7,665.4,569.7,665.3,569.7,665.3z"/>
				<path d="M574.4,666h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C574.7,666.1,574.6,666,574.4,666z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(19)">
		<v-touch tag="a" v-on:tap="mostarIntervencao(19)">
	<circle class="st2" cx="542.2" cy="659.4" r="14.5"/>
	<circle class="st3" cx="542.2" cy="659.4" r="13"/>
	<circle class="st4" cx="542.2" cy="659.4" r="11.7"/>
	<path class="st5" d="M542.2,671.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C554.6,666.2,549,671.8,542.2,671.8z M542.2,648.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C553.2,653.2,548.3,648.3,542.2,648.3L542.2,648.3z"/>
	<path class="st6" d="M542.2,659.4L542.2,659.4L542.2,659.4z"/>
	<g>
		<g>
			<g>
				<path d="M546.2,654.3H545v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C547.5,654.9,546.9,654.3,546.2,654.3z M540,654.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H540L540,654.1L540,654.1z M546.9,665c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L546.9,665
					L546.9,665z"/>
				<path d="M540.9,659.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C541,660.1,541,659.9,540.9,659.8L540.9,659.8z"/>
				<path d="M545.6,660.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S545.8,660.5,545.6,660.5z"/>
				<path d="M540.9,657.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C541,657.5,541,657.3,540.9,657.2L540.9,657.2z"/>
				<path d="M545.6,657.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C545.9,658,545.8,657.9,545.6,657.9z"/>
				<path d="M540.9,662.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C541,662.7,541,662.5,540.9,662.4L540.9,662.4z"/>
				<path d="M545.6,663.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S545.8,663.1,545.6,663.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(21)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(21)">
	<circle class="st2" cx="594.4" cy="795.2" r="14.5"/>
	<circle class="st3" cx="594.4" cy="795.2" r="13"/>
	<circle class="st4" cx="594.4" cy="795.2" r="11.7"/>
	<path class="st5" d="M594.5,807.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4l0,0
		C606.9,802.1,601.3,807.6,594.5,807.7z M594.5,784.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C605.5,789.1,600.6,784.2,594.5,784.2L594.5,784.2z"/>
	<polygon class="st6" points="594.5,795.2 594.5,795.2 594.4,795.2 	"/>
	<g>
		<g>
			<g>
				<path d="M598.5,790.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H592
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C599.8,790.8,599.2,790.2,598.5,790.2z M592.3,790h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L592.3,790L592.3,790z M599.2,800.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L599.2,800.9
					L599.2,800.9z"/>
				<path d="M593.2,795.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C593.3,796,593.3,795.8,593.2,795.7L593.2,795.7z"/>
				<path d="M597.9,796.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S598.1,796.4,597.9,796.4z"/>
				<path d="M593.2,793.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C593.3,793.4,593.3,793.2,593.2,793.1L593.2,793.1z"/>
				<path d="M597.9,793.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S598.1,793.8,597.9,793.8z"/>
				<path d="M593.2,798.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C593.3,798.6,593.3,798.4,593.2,798.3L593.2,798.3z"/>
				<path d="M597.9,799h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S598.1,799,597.9,799z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(18)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(18)">
	<circle class="st2" cx="732.5" cy="540.4" r="14.5"/>
	<circle class="st3" cx="732.5" cy="540.4" r="13"/>
	<circle class="st4" cx="732.5" cy="540.4" r="11.7"/>
	<path class="st5" d="M732.5,552.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C744.9,547.3,739.3,552.8,732.5,552.8z M732.5,529.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C743.5,534.3,738.6,529.3,732.5,529.3L732.5,529.3z"/>
	<polygon class="st6" points="732.5,540.4 732.5,540.4 732.4,540.4 	"/>
	<g>
		<g>
			<g>
				<path d="M736.5,535.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H730
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C737.8,535.9,737.2,535.4,736.5,535.3z M730.3,535.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L730.3,535.2L730.3,535.2z M737.2,546c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V536h1.2c0.4,0,0.7,0.3,0.7,0.7L737.2,546
					L737.2,546z"/>
				<path d="M731.2,540.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C731.3,541.2,731.3,541,731.2,540.8C731.2,540.9,731.2,540.9,731.2,540.8z
					"/>
				<path d="M735.9,541.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S736.1,541.5,735.9,541.5z"/>
				<path d="M731.2,538.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C731.3,538.6,731.3,538.4,731.2,538.2L731.2,538.2z"/>
				<path d="M735.9,538.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C736.2,539.1,736.1,538.9,735.9,538.9z"/>
				<path d="M731.2,543.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C731.3,543.8,731.3,543.6,731.2,543.5L731.2,543.5z"/>
				<path d="M735.9,544.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S736.1,544.2,735.9,544.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(12)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(12)">
	<circle class="st2" cx="839.5" cy="347.4" r="14.5"/>
	<circle class="st3" cx="839.5" cy="347.4" r="13"/>
	<circle class="st4" cx="839.5" cy="347.4" r="11.7"/>
	<path class="st5" d="M839.5,359.8c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C851.9,354.3,846.3,359.8,839.5,359.8z M839.5,336.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C850.5,341.3,845.6,336.3,839.5,336.3L839.5,336.3z"/>
	<path class="st6" d="M839.5,347.4L839.5,347.4L839.5,347.4z"/>
	<g>
		<g>
			<g>
				<path d="M843.5,342.4h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H837
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C844.8,342.9,844.2,342.4,843.5,342.4z M837.4,342.2h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L837.4,342.2L837.4,342.2z M844.2,353c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V343h1.2c0.4,0,0.7,0.3,0.7,0.7L844.2,353
					L844.2,353z"/>
				<path d="M838.2,347.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C838.3,348.2,838.3,348,838.2,347.9L838.2,347.9z"/>
				<path d="M842.9,348.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S843.1,348.6,842.9,348.6z"
					/>
				<path d="M838.2,345.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C838.3,345.6,838.3,345.4,838.2,345.2
					C838.2,345.3,838.2,345.2,838.2,345.2z"/>
				<path d="M842.9,345.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C843.2,346.1,843.1,345.9,842.9,345.9z"/>
				<path d="M838.2,350.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C838.3,350.8,838.3,350.6,838.2,350.5L838.2,350.5z"/>
				<path d="M842.9,351.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S843.1,351.2,842.9,351.2z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(14)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(14)">
	<circle class="st2" cx="892.9" cy="370.3" r="14.5"/>
	<circle class="st3" cx="892.9" cy="370.3" r="13"/>
	<circle class="st4" cx="892.9" cy="370.3" r="11.7"/>
	<path class="st5" d="M892.9,382.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C905.3,377.1,899.7,382.7,892.9,382.7z M892.9,359.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C903.9,364.2,899,359.2,892.9,359.2L892.9,359.2z"/>
	<path class="st6" d="M892.9,370.3L892.9,370.3L892.9,370.3z"/>
	<g>
		<g>
			<g>
				<path d="M896.9,365.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C898.2,365.8,897.6,365.2,896.9,365.2z M890.7,365.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L890.7,365.1L890.7,365.1z M897.6,375.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L897.6,375.9L897.6,375.9z"/>
				<path d="M891.6,370.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C891.7,371.1,891.7,370.9,891.6,370.7L891.6,370.7z"/>
				<path d="M896.3,371.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C896.6,371.6,896.5,371.4,896.3,371.4z"/>
				<path d="M891.6,368.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C891.7,368.5,891.7,368.3,891.6,368.1L891.6,368.1z"/>
				<path d="M896.3,368.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C896.6,369,896.5,368.8,896.3,368.8z"/>
				<path d="M891.6,373.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C891.7,373.7,891.7,373.5,891.6,373.3
					C891.6,373.4,891.6,373.3,891.6,373.3z"/>
				<path d="M896.3,374h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S896.5,374,896.3,374z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(10)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(10)">
	<circle class="st2" cx="693.2" cy="316.2" r="14.5"/>
	<circle class="st3" cx="693.2" cy="316.2" r="13"/>
	<circle class="st4" cx="693.2" cy="316.2" r="11.7"/>
	<path class="st5" d="M693.2,328.6c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C705.7,323,700.1,328.6,693.2,328.6z M693.2,305.1c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C704.3,310.1,699.4,305.1,693.2,305.1L693.2,305.1z"/>
	<path class="st6" d="M693.2,316.2L693.2,316.2L693.2,316.2z"/>
	<g>
		<g>
			<g>
				<path d="M697.3,311.1H696v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C698.6,311.7,698,311.1,697.3,311.1z M691.1,311h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L691.1,311L691.1,311z M698,321.8c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L698,321.8
					L698,321.8z"/>
				<path d="M692,316.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C692.1,317,692.1,316.8,692,316.6L692,316.6z"/>
				<path d="M696.7,317.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C697,317.5,696.8,317.3,696.7,317.3z"/>
				<path d="M692,314c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C692.1,314.4,692.1,314.2,692,314L692,314z"/>
				<path d="M696.7,314.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C697,314.9,696.8,314.7,696.7,314.7z"/>
				<path d="M692,319.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C692.1,319.6,692.1,319.4,692,319.2L692,319.2z"/>
				<path d="M696.7,319.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S696.8,319.9,696.7,319.9z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(13)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(13)">
	<circle class="st2" cx="830.8" cy="399.3" r="14.5"/>
	<circle class="st3" cx="830.8" cy="399.3" r="13"/>
	<circle class="st4" cx="830.8" cy="399.3" r="11.7"/>
	<path class="st5" d="M830.8,411.8c-6.9,0-12.4-5.6-12.4-12.4S824,387,830.8,387c6.9,0,12.4,5.6,12.4,12.4l0,0
		C843.3,406.2,837.7,411.7,830.8,411.8z M830.8,388.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C841.9,393.2,837,388.3,830.8,388.3L830.8,388.3z"/>
	<path class="st6" d="M830.8,399.3L830.8,399.3L830.8,399.3z"/>
	<g>
		<g>
			<g>
				<path d="M834.9,394.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C836.2,394.9,835.6,394.3,834.9,394.3z M828.7,394.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L828.7,394.1L828.7,394.1z M835.6,404.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L835.6,404.9L835.6,404.9z"/>
				<path d="M829.6,399.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C829.7,400.1,829.7,399.9,829.6,399.8L829.6,399.8z"/>
				<path d="M834.3,400.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S834.5,400.5,834.3,400.5z"
					/>
				<path d="M829.6,397.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C829.7,397.5,829.7,397.3,829.6,397.2L829.6,397.2z"/>
				<path d="M834.3,397.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S834.5,397.9,834.3,397.9z"
					/>
				<path d="M829.6,402.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C829.7,402.7,829.7,402.5,829.6,402.4L829.6,402.4z"/>
				<path d="M834.3,403.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S834.5,403.1,834.3,403.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(7)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(7)">
	<circle class="st2" cx="661.2" cy="177.7" r="14.5"/>
	<circle class="st3" cx="661.2" cy="177.7" r="13"/>
	<circle class="st4" cx="661.2" cy="177.7" r="11.7"/>
	<path class="st5" d="M661.2,190.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4l0,0
		C673.6,184.5,668.1,190.1,661.2,190.1z M661.2,166.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C672.3,171.6,667.3,166.6,661.2,166.6L661.2,166.6z"/>
	<path class="st6" d="M661.2,177.7L661.2,177.7L661.2,177.7z"/>
	<g>
		<g>
			<g>
				<path d="M665.2,172.6H664V172c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C666.5,173.2,665.9,172.6,665.2,172.6
					z M659.1,172.5h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L659.1,172.5L659.1,172.5z M665.9,183.3c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L665.9,183.3L665.9,183.3z"/>
				<path d="M659.9,178.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C660.1,178.5,660.1,178.3,659.9,178.1C660,178.1,659.9,178.1,659.9,178.1z
					"/>
				<path d="M664.6,178.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S664.8,178.8,664.6,178.8z"/>
				<path d="M659.9,175.5c-0.1-0.1-0.3-0.1-0.5,0l-1,1L658,176c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C660.1,175.9,660.1,175.7,659.9,175.5C660,175.5,659.9,175.5,659.9,175.5z
					"/>
				<path d="M664.6,176.2h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S664.8,176.2,664.6,176.2z"/>
				<path d="M659.9,180.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C660.1,181.1,660.1,180.9,659.9,180.7C660,180.7,659.9,180.7,659.9,180.7z
					"/>
				<path d="M664.6,181.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C664.9,181.6,664.8,181.4,664.6,181.4z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(4)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(4)">
	<circle class="st2" cx="434.3" cy="333" r="14.5"/>
	<circle class="st3" cx="434.3" cy="333" r="13"/>
	<circle class="st4" cx="434.3" cy="333" r="11.7"/>
	<path class="st5" d="M434.3,345.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C446.7,339.9,441.1,345.4,434.3,345.4z M434.3,321.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C445.3,326.9,440.4,321.9,434.3,321.9L434.3,321.9z"/>
	<path class="st6" d="M434.3,333L434.3,333L434.3,333z"/>
	<g>
		<g>
			<g>
				<path d="M438.3,327.9H437v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C439.6,328.5,439,327.9,438.3,327.9z M432.1,327.8h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L432.1,327.8L432.1,327.8z M439,338.6c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V338.6
					L439,338.6z"/>
				<path d="M433,333.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C433.1,333.8,433.1,333.6,433,333.4L433,333.4z"/>
				<path d="M437.7,334.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C438,334.3,437.9,334.1,437.7,334.1z"/>
				<path d="M433,330.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C433.1,331.2,433.1,331,433,330.8L433,330.8z"/>
				<path d="M437.7,331.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C438,331.7,437.9,331.5,437.7,331.5z"/>
				<path d="M433,336c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C433.1,336.4,433.1,336.2,433,336C433,336.1,433,336.1,433,336z"/>
				<path d="M437.7,336.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S437.9,336.8,437.7,336.8z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(5)">
		<v-touch tag="a" v-on:tap="mostarIntervencao(5)">
	<circle class="st2" cx="442.1" cy="190.1" r="14.5"/>
	<circle class="st3" cx="442.1" cy="190.1" r="13"/>
	<circle class="st4" cx="442.1" cy="190.1" r="11.7"/>
	<path class="st5" d="M442.1,202.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C454.5,197,448.9,202.5,442.1,202.5z M442.1,179c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C453.1,184,448.2,179,442.1,179L442.1,179z"/>
	<polygon class="st6" points="442.1,190.1 442.1,190.1 442,190.1 	"/>
	<g>
		<g>
			<g>
				<path d="M446.1,185.1h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6H438c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C447.4,185.6,446.8,185.1,446.1,185.1z M439.9,184.9h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L439.9,184.9L439.9,184.9z M446.8,195.7c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V195.7
					L446.8,195.7z"/>
				<path d="M440.8,190.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C440.9,190.9,440.9,190.7,440.8,190.6L440.8,190.6z"/>
				<path d="M445.5,191.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S445.7,191.3,445.5,191.3z"/>
				<path d="M440.8,187.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C440.9,188.3,440.9,188.1,440.8,187.9C440.8,188,440.8,187.9,440.8,187.9z"/>
				<path d="M445.5,188.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C445.8,188.8,445.7,188.6,445.5,188.6z"/>
				<path d="M440.8,193.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C440.9,193.5,440.9,193.3,440.8,193.2L440.8,193.2z"/>
				<path d="M445.5,193.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S445.7,193.9,445.5,193.9z"/>
			</g>
		</g>
	</g>
		</v-touch>
</g>
<g @click="mostarIntervencao(1)">
		<v-touch tag="a" v-on:tap="mostarIntervencao(1)">
		<ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -278.5862 659.3612)" class="st2" cx="248.2" cy="493.4" rx="14.5" ry="14.5"/>

		<ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -278.5862 659.3612)" class="st3" cx="248.2" cy="493.4" rx="13" ry="13"/>
	<circle class="st4" cx="248.2" cy="493.4" r="11.7"/>
	<path class="st5" d="M248.2,505.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C260.6,500.2,255.1,505.8,248.2,505.8z M248.2,482.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C259.3,487.2,254.3,482.3,248.2,482.3L248.2,482.3z"/>
	<path class="st6" d="M248.2,493.4L248.2,493.4L248.2,493.4z"/>
	<g>
		<g>
			<g>
				<path d="M252.2,488.3H251v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C253.6,488.9,252.9,488.3,252.2,488.3z M246.1,488.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L246.1,488.1L246.1,488.1z M252.9,499c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L252.9,499L252.9,499z"/>
				<path d="M246.9,493.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C247.1,494.1,247.1,493.9,246.9,493.8C247,493.8,247,493.8,246.9,493.8z"
					/>
				<path d="M251.6,494.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C252,494.6,251.8,494.5,251.6,494.5z"/>
				<path d="M246.9,491.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C247.1,491.5,247.1,491.3,246.9,491.2C247,491.2,247,491.2,246.9,491.2z"
					/>
				<path d="M251.6,491.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C252,492,251.8,491.9,251.6,491.9z"/>
				<path d="M246.9,496.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C247.1,496.7,247.1,496.6,246.9,496.4C247,496.4,247,496.4,246.9,496.4z"
					/>
				<path d="M251.6,497.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S251.8,497.1,251.6,497.1z"/>
			</g>
		</g>
	</g>
		</v-touch>
</g>
<g @click="mostarIntervencao(2)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(2)">
	<circle class="st2" cx="224.7" cy="506.6" r="14.5"/>
	<circle class="st3" cx="224.7" cy="506.6" r="13"/>
	<circle class="st4" cx="224.7" cy="506.6" r="11.7"/>
	<path class="st5" d="M224.7,519c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C237.1,513.5,231.6,519,224.7,519z M224.7,495.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C235.8,500.5,230.8,495.5,224.7,495.5L224.7,495.5z"/>
	<path class="st6" d="M224.7,506.6L224.7,506.6L224.7,506.6z"/>
	<g>
		<g>
			<g>
				<path d="M228.7,501.5h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C230.1,502.1,229.5,501.6,228.7,501.5z M222.6,501.4h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L222.6,501.4L222.6,501.4z M229.5,512.2c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L229.5,512.2L229.5,512.2z"/>
				<path d="M223.5,507c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C223.6,507.4,223.6,507.2,223.5,507C223.5,507.1,223.5,507.1,223.5,507z"
					/>
				<path d="M228.1,507.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S228.3,507.7,228.1,507.7z"/>
				<path d="M223.5,504.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C223.6,504.8,223.6,504.6,223.5,504.4L223.5,504.4z"/>
				<path d="M228.1,505.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C228.5,505.3,228.3,505.1,228.1,505.1z"/>
				<path d="M223.5,509.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C223.6,510,223.6,509.8,223.5,509.7L223.5,509.7z"/>
				<path d="M228.1,510.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C228.5,510.5,228.3,510.4,228.1,510.4z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(15)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(15)">
	<circle class="st2" cx="904" cy="466.5" r="14.5"/>
	<circle class="st3" cx="904" cy="466.5" r="13"/>
	<circle class="st4" cx="904" cy="466.5" r="11.7"/>
	<g>
		<path class="st5" d="M904,479c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C916.4,473.4,910.9,479,904,479z M904,455.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C915.1,460.4,910.1,455.5,904,455.5L904,455.5z"/>
		<g>
			<path class="st6" d="M907.7,464.8c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C907.9,465.2,907.9,465,907.7,464.8z"/>
			<path class="st6" d="M899.8,463.1c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C899.7,462.6,899.7,462.9,899.8,463.1L899.8,463.1z"/>
			<path class="st6" d="M911.1,461.3h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6V462C911.7,461.6,911.4,461.3,911.1,461.3z M910.9,470.9h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L910.9,470.9L910.9,470.9z"/>
		</g>
	</g>
	</v-touch>
</g>
</svg>

</SvgPanZoom>
      </div>
    </div>
  </div>
</template>


<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import { mapActions } from 'vuex'
import Modal from '@/components/ModalMapas.vue'

export default {
	components: { SvgPanZoom, Modal },

	data () {
		return {
			informacoes: [
				{
            id: 1,
            titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Alta Vulnerabilidade a Inundações – Bacia Hidrográfica do Rio Acre',
            desc: 'Definição de alternativas de intervenções para prevenir e mitigar os efeitos das cheias na bacia hidrográfica do rio Acre (AC/AM)',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 3,80 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR Cheias-Bacia Acre.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 2,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 3,
            titulo: 'Sistema Adutor de Porto Velho',
            desc: 'Abastecimento humano de Porto Velho',
            estagio: 'Obra',
          	valor: 'R$ 166,04 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_RO-001.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 4,
            titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a Região Metropolitana de Manaus',
            desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Manaus',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 3,00 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Manaus.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 5,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 6,
            titulo: 'Sistema Adutor de Macapá (ampliação)',
            desc: 'Abastecimento humano de Macapá',
            estagio: 'Obra',
          	valor: 'R$ 151,13 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_AP-001.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 7,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 8,
            titulo: 'Sistema Adutor Complexo Bolonha (ampliação)',
            desc: 'Abastecimento humano de Belém, Ananindeua e Marituba',
            estagio: 'Obra',
          	valor: 'R$ 158,66 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PA-001_Uni_LP.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 9,
            titulo: 'Sistema Adutor Marabá (ampliação)',
            desc: 'Abastecimento humano de Marabá',
            estagio: 'Obra',
          	valor: 'R$ 54,58 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PA-003.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 10,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 11,
            titulo: 'Sistema Adutor Italuís II (ampliação)',
            desc: 'Abastecimento humano de São Luís, Bacabeira e São Jose do Ribamar',
            estagio: 'Obra',
          	valor: 'R$ 668,80 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_MA-001_Uni_LP.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 12,
            titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM São Luís',
            desc: 'Definição de alternativa para o abastecimento humano da Região Metropolitana de São Luís',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 3,00 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Sao Luis.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 13,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 14,
            titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica (Ride) de Teresina',
            desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica nas bacias situadas na Ride de Teresina',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 1,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-RIDE Teresina.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 15,
            titulo: 'Canal do Sertão Piauiense (Eixo Oeste)',
            desc: 'Usos múltiplos em 26 municípios na bacia hidrográfica do rio Parnaíba',
            estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
          	valor: 'R$ 18,50 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 16,
            titulo: 'Sistema Adutor do Litoral',
            desc: 'Abastecimento humano de Parnaíba, Ilha Grande, Luís Correia e Cajueiro da Praia',
            estagio: 'Obra',
          	valor: 'R$ 70,35 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_PI-010.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 17,
            titulo: 'Sistema Adutor de Palmas (ampliação)',
            desc: 'Abastecimento humano de Palmas',
            estagio: 'Projeto Executivo',
          	valor: 'R$ 41,79 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_TO-001.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 18,
            titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica - Bacia Hidrográfica do Rio Formoso',
            desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na bacia hidrográfica do rio Formoso',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 1,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacia Rio Formoso.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 19,
            titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Cuiabá',
            desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Cuiabá',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 3,00 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Cuiaba.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 20,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 21,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 22,
            titulo: 'Sistema Adutor de Anápolis',
            desc: 'Abastecimento humano de Anápolis',
            estagio: 'Obra',
          	valor: 'R$ 123,19 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_GO-014.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 23,
            titulo: 'Sistema Adutor de Águas Lindas',
            desc: 'Abastecimento humano de Águas Lindas',
            estagio: 'Obra',
          	valor: 'R$ 141,42 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_GO-015.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 24,
            titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a Região Integrada de Desenvolvimento do Distrito Federal',
            desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Integrada de Desenvolvimento do Distrito Federal',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 4,80 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Distrito Federal.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 25,
            titulo: 'Estudo de Refinamento do Índice de Segurança Hídrica em Unidades Territoriais de Análise',
            desc: 'Refinamento do ISH de modo a confirmar os deficits hídricos identificados no PNSH',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 0,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_Lacunas-Geral.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 26,
            titulo: 'Sistema Adutor Corumbá IV',
            desc: 'Abastecimento humano do Gama, Santa Maria, Planaltina, Recanto das Emas e Riacho Fundo, no DF, e Cidade Ocidental, Luziânia, Novo Gama e Valparaíso, em Goiás',
            estagio: 'Obra',
          	valor: 'R$ 150,93 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_CO-001_Uni_LP.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 27,
            titulo: 'Sistema Adutor Lago Paranoá',
            desc: 'Abastecimento humano do Paranoá, Lago Oeste, Tororó, Sobradinho e Condomínios Jardim ABC, Jardim Botânico e Alphaville',
            estagio: 'Obra',
          	valor: 'R$ 523,25 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_DF-001_Uni_LP.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 28,
            titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Goiânia',
            desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Goiânia',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 3,00 milhões',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Goiania.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 29,
            titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica - Bacias Hidrográficas dos Rios Paranaíba, Grande e Paranapanema',
            desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprim. dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rios Paranaíba, Grande e Paranapanema',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 1,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Paranaiba Grande e Panema.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
				{
            id: 30,
            titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacias Hidrográficas dos rios Paranaíba, Grande e Paranapanema',
            desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprim. dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rios Paranaíba, Grande e Paranapanema',
            estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
          	valor: 'R$ 1,80 milhão',
            icons: null,
            show: true,
            pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Paranaiba Grande e Panema.pdf',
            posicao: {
              top: 20,
              left: 20,
							right: 0,
							bottom: 0
            },
				},
			]
		}
	},

  methods: {
    ...mapActions({
        showModal: 'Layout/enviarInformacaoModal'
    }),
    mostarIntervencao (item, evt) {
      let payload = this.informacoes.filter((value) => {
          return value.id === item
			})

      this.showModal(payload[0]);
    }
  }
}
</script>


<style lang="scss" scoped>

.title-section {
    padding-left: 0px;
    height: 40px;
}

.downloand {
	max-height: 35vh;
  overflow: auto;
}

.interacao-intervencao {
	display: flex;
	align-items: center;
    width: 289px;
    @include media_tablet() {
      display: none;
    }
	svg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	p {
		font-family: 'rubik_italic';
		font-size: 12px;
		line-height: 16px;
	}
}

svg {
    height: 450px;
    width: 100%;
    @media (max-height:  900px) and (min-width: 1200px)   {
        height: 350px;
    }
}
.st0{fill:#3B6EB6;}
	.st1{fill:#8AD7F8;}
	.st2{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}
	.st3{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}
	.st4{fill:#FFFFFF;}
	.st5{fill:#8FC74B;}
	.st6{fill:#010101;}
</style>
